var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHyperlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6386",
    "data-name": "Grupo 6386",
    transform: "translate(-811 -396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_in_new_24dp_5F6368_FILL0_wght400_GRAD0_opsz24-2",
    d: "M122-822a1.926,1.926,0,0,1-1.413-.587A1.926,1.926,0,0,1,120-824v-14a1.926,1.926,0,0,1,.587-1.412A1.926,1.926,0,0,1,122-840h6a.968.968,0,0,1,.713.287A.968.968,0,0,1,129-839a.968.968,0,0,1-.288.713A.968.968,0,0,1,128-838h-6v14h14v-6a.968.968,0,0,1,.287-.713A.968.968,0,0,1,137-831a.968.968,0,0,1,.712.287A.968.968,0,0,1,138-830v6a1.926,1.926,0,0,1-.588,1.413A1.926,1.926,0,0,1,136-822Zm14-14.6-8.6,8.6a.948.948,0,0,1-.7.275A.948.948,0,0,1,126-828a.948.948,0,0,1-.275-.7.948.948,0,0,1,.275-.7l8.6-8.6H132a.968.968,0,0,1-.713-.287A.968.968,0,0,1,131-839a.968.968,0,0,1,.287-.713A.968.968,0,0,1,132-840h5a.968.968,0,0,1,.712.287A.968.968,0,0,1,138-839v5a.967.967,0,0,1-.288.712A.967.967,0,0,1,137-833a.968.968,0,0,1-.713-.288A.967.967,0,0,1,136-834Z",
    transform: "translate(694 1238.999)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2054",
    "data-name": "Ret\\xE2ngulo 2054",
    width: 24,
    height: 24,
    transform: "translate(811 396)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHyperlink);
export default __webpack_public_path__ + "static/media/icon_hyperlink.f4acd273.svg";
export { ForwardRef as ReactComponent };